import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Select,
  Image,
  Table,
  Input,
  Modal,
  notification,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import Category from "../../components/updateCategory/updateCategory";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddCategoryModalVisible, setIsAddCategoryModalVisible] =
    useState(false);
  const [expandedDescription, setExpandedDescription] = useState(null);

  const getAllCategories = () => {
    callApi("GET", routes.getAllCategories, null, setIsLoading, (res) => {
      console.log("Response of the Category", res);
      setCategories(res?.data?.categories || []);
    });
  };

  useEffect(() => {
    getAllCategories();
  }, []);
  const showFullDescription = (text) => {
    Modal.info({
      title: "Description",
      content: (
        <div>
          <p style={{ textAlign: "justify" }}>{text}</p>
        </div>
      ),
      onOk() {},
    });
  };
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteCategory}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setCategories((prevVideos) =>
            prevVideos.filter((video) => video._id !== recordId)
          );
          GreenNotify("Category Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setUpdateRecordData(null);
    setIsAddCategoryModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    console.log("recordid", recordId);
    const selectedCategory = categories.find((cat) => cat._id === recordId);
    setUpdateRecordData(selectedCategory);
    setIsAddCategoryModalVisible(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Content",
      dataIndex: "content",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          {expandedDescription === record.key ? (
            <span>{text}</span>
          ) : (
            <div>
              <span>{`${text.slice(0, 50)}...`}</span>
              <Button type="link" onClick={() => showFullDescription(text)}>
                See More
              </Button>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Icon",
      dataIndex: "icon",
      align: "center",
      render: (icon) => (
        <div className="product-list-image">
          <Image
            style={{
              width: 100,
              height: 100,
              borderRadius: 50,
              objectFit: "cover",
            }}
            src={icon}
            alt="category-icon"
          />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = categories
    ?.map((item, index) => {
      const mappedItem = {
        key: item?._id,
        _id: item?._id,
        title: item?.title || "not-available",
        content: item?.content || " not-available",
        icon: item?.icon || "not-available",
      };
      return mappedItem;
    })
    .filter((item) =>
      item?.title?.toLowerCase().includes(searchText.toLowerCase())
    );

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Categories</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Categories</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Category
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <Category
        visible={isAddCategoryModalVisible}
        toggleModal={() => {
          setIsAddCategoryModalVisible(false);
          getAllCategories();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default Organizers;
